import { CircularProgress } from '@mui/material'
import colors from 'styles/colors'
import { ReactNode } from 'react'

interface ConditionallyRenderProps {
  when: ReactNode
  otherwise?: ReactNode
  condition: boolean
  isLoading?: boolean
}

const ConditionallyRender = ({
  when,
  otherwise = null,
  condition,
  isLoading,
}: ConditionallyRenderProps) => {
  return (
    <>
      {isLoading ? (
        <CircularProgress sx={{ color: colors?.risikaContrast }} />
      ) : condition ? (
        when
      ) : (
        otherwise
      )}
    </>
  )
}

export default ConditionallyRender
